import { genPageTheme, shapes } from '@backstage/theme';

/**
 * Creates a Backstage page theme with a wave-shaped header background using a two-color gradient.
 * @param colors - An array with two hex color strings forming the gradient, e.g. `['#3c6266', '#41878e']`
 */
export const waveTheme = (colors: [string, string]) => genPageTheme({ colors, shape: shapes.wave });

/**
 * Named page themes used across Varia.
 *
 * Each key corresponds to a `themeId` that can be set on a Backstage `<Page>` or
 * `<PageWithHeader>` component to control the color of that page's header banner:
 */
export const pageThemes = {
  home: waveTheme(['#206f77', '#1f6369']),
  documentation: waveTheme(['#33607e', '#2e82b7']),
};
